import { FC } from 'react';

import { IMAGES_PATH } from '@telialt/assets/src/constants';
import { useSegment } from '@telialt/utils/src/segment';

type BadgeSupportedBrand = 'Apple' | 'Google';
type BadgeSupportedLanguage = 'lt' | 'en';

const getBadgeSrc = (language: BadgeSupportedLanguage, brand: BadgeSupportedBrand) => {
    if (language === 'lt' && brand === 'Apple') {
        return 'download-from-app-store-black-lt.svg';
    } else if (language === 'lt' && brand === 'Google') {
        return 'download-from-google-play-black-lt.svg';
    } else if (language === 'en' && brand === 'Apple') {
        return 'download-from-app-store-black-en.svg';
    } else if (language === 'en' && brand === 'Google') {
        return 'download-from-google-play-black-en.svg';
    } else if (brand === 'Apple') {
        return 'download-from-app-store-black-en.svg';
    } else if (brand === 'Google') {
        return 'download-from-google-play-black-en.svg';
    } else {
        return null;
    }
};

type Props = { brand: BadgeSupportedBrand };

export const StoreBadge: FC<Props> = ({ brand }) => {
    const segment = useSegment();
    const language: BadgeSupportedLanguage = segment === 'english' ? 'en' : 'lt';
    const badgeSrc = getBadgeSrc(language, brand);

    if (!badgeSrc) {
        return null;
    }

    return (
        <img
            height={48}
            width={162}
            role="presentation"
            alt=""
            src={`${IMAGES_PATH}/${badgeSrc}?v=${process.env.GIT_HASH}`}
        />
    );
};
